export const FETCH_MY_ACTIVITY_REQUEST = 'activity/FETCH_MY_ACTIVITY_REQUEST';
export const FETCH_MY_ACTIVITY_SUCCESS = 'activity/FETCH_MY_ACTIVITY_SUCCESS';
export const FETCH_MY_ACTIVITY_FAILURE = 'activity/FETCH_MY_ACTIVITY_FAILURE';

